import React from 'react'
import { MdBlock } from 'react-icons/md'

import { Container, ContainerItem } from 'components'

import { Box, Typography } from '@material-ui/core'

const NoPermission: React.FC = () => {
  return (
    <Container>
      <ContainerItem xs={12} paper>
        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          minHeight="60vh"
          p={4}
        >
          <MdBlock size={64} color="#f44336" />
          <Typography variant="h4" align="center" gutterBottom style={{ marginTop: '20px' }}>
            Acesso Negado
          </Typography>
          <Typography variant="body1" align="center" color="textSecondary">
            Você não possui permissões para acessar nenhuma área do sistema.
          </Typography>
          <Typography variant="body2" align="center" color="textSecondary" style={{ marginTop: '10px' }}>
            Entre em contato com o administrador do sistema para solicitar as permissões necessárias.
          </Typography>
        </Box>
      </ContainerItem>
    </Container>
  )
}

export default NoPermission
